// Runtime control object to avoid duplicate processing & popup spam
var _buyXGetYRuntime = {
	lastCartHash: null,
	debounceTimer: null,
	pendingPromoVariants: new Set(),
	debug: true,
	hashCart: function(cart){
		try {
			if(!cart || !cart.items) return "";
			return cart.items.map(i => i.variant_id+":"+i.quantity).sort().join("|");
		} catch(e){ return ""; }
	},
	log: function(){ if(this.debug && console && console.log) console.log.apply(console, ["[BuyXGetY]"].concat([].slice.call(arguments))); }
};

var buyXgetYData = {
	buy_x_get_y: [],
	getBuyXGetY: function() {
		let self = this
		try {
			if(typeof storeSpecialData === 'undefined' || !storeSpecialData.buy_x_get_y){
				console.warn('[BuyXGetY] storeSpecialData.buy_x_get_y not defined');
				return;
			}
			fetch(storeSpecialData.buy_x_get_y)
				.then(function(response){ return response.json(); })
				.then(function(data){
					if(!Array.isArray(data)) { console.warn('[BuyXGetY] invalid promo data'); return; }
					console.info('getBuyXGetY', data);
					// Normalize & sort once
					self.buy_x_get_y = data.map(function(p){
						if(Array.isArray(p.get_variants_ids)) p.get_variants_ids = p.get_variants_ids.map(function(v){return parseInt(v,10);}).filter(function(v){return !isNaN(v);});
						if(Array.isArray(p.buy_variants_ids)) p.buy_variants_ids = p.buy_variants_ids.map(function(v){return parseInt(v,10);}).filter(function(v){return !isNaN(v);});
						return p;
					}).sort(function(a,b){
						var av = parseFloat(a.buy_value||0) || 0;
						var bv = parseFloat(b.buy_value||0) || 0;
						return av - bv;
					});
					// After data loads, evaluate in case cart already qualifies
					if(typeof scheduleBuyXGetY === 'function') scheduleBuyXGetY();
				})
				.catch(function(err){ console.warn('[BuyXGetY] fetch promos failed', err); });
		} catch(e){ console.warn('[BuyXGetY] getBuyXGetY error', e); }
	},
	addBuyXGetY: function(product, objRef, cart, qty) {
	  /**
	   * This method will add a product in the cart if some condition are meet
	   * It will also work if we click on (+) to add more quantity to an item.
	   * 
	   * (TO DO): it would be great to have another function in charge of removing
	   *          items that do not meet any condition once clicked on (-) 
	   */
	  
		console.info("addBuyXGetY", product);
		console.info("getCart", cart);
		console.info("qtyqty", qty);

		if(!Array.isArray(this.buy_x_get_y))
			return;

		/**
		 * get a list of all variant ID in our cart
		 */
		var idVariantCurrentCartList = [];
		if(product)
			idVariantCurrentCartList.push(parseInt(product.variant_id))

		// we need to considere the new quantity in case we add one more item already present in the cart.
		var prdQty = qty;
		if(product){
			prdQty = product.quantity;
		}

		cart.items.forEach(item => {
			idVariantCurrentCartList.push(parseInt(item.variant_id));
		});

		var itemsToCreate = [];

		/**
		 * Need to group per type and value
		 */
		var listObjPerVendorValue = {};
		
		let self = this;
		cart.items.forEach(function(item) {
			// Check if this item is not a free item from any promotion
			var isFreeItem = false;
			for(var i = 0; i < self.buy_x_get_y.length; i++) {
				var promo = self.buy_x_get_y[i];
				if(promo.get_variants_ids.indexOf(parseInt(item.variant_id)) !== -1){
					isFreeItem = true;
					break;
				}
			}
			
			// We sum the prices of all items in our cart except the items added for free.
			if(!isFreeItem){
				var vLower = item.vendor.toLowerCase();
				if(!(vLower in listObjPerVendorValue)){
					listObjPerVendorValue[vLower] = item.price / 100 * item.quantity;
				}else{
					listObjPerVendorValue[vLower] += item.price / 100 * item.quantity;
				}
			}
		});

		console.info("listObjPerVendorValue", listObjPerVendorValue);
		
		this.buy_x_get_y.forEach(function(promo){
			var promoApplicable = true;
			var spendQualified = true;
			var totalSpend = 0;

			// COLLECTION / VENDOR SPEND LOGIC: treat collections as OR (any qualifying), case-insensitive
			if(promo.buy_collections && promo.buy_collections.length && promo.buy_value){
				var wantedHandles = promo.buy_collections.map(function(c){ return (c.handle || c.title || '').replace(/-/g, " ").toString().toLowerCase(); });
				// Sum spend for any vendor whose lower-case name OR handle matches one of the collection handles/titles
				
				Object.keys(listObjPerVendorValue).forEach(function(vendorName){
					var vLower = vendorName.toLowerCase();
					console.info("sfsdfsdfsdf", wantedHandles, vLower);
					if(wantedHandles.indexOf(vLower) !== -1) {
						totalSpend += listObjPerVendorValue[vendorName];
					}
				});
				console.info("Total spend for promo", promo.id || (promo.get_variants_ids && promo.get_variants_ids[0]), totalSpend, "needed:", promo.buy_value);
				if(totalSpend < parseFloat(promo.buy_value)) spendQualified = false;
				if(!spendQualified) promoApplicable = false;
			}

			// VARIANT PRESENCE LOGIC (ALL required variants must be present if defined)
			if(promoApplicable && Array.isArray(promo.buy_variants_ids) && promo.buy_variants_ids.length){
				for(var i=0;i<promo.buy_variants_ids.length;i++){
					if(idVariantCurrentCartList.indexOf(promo.buy_variants_ids[i]) === -1){
						promoApplicable = false; break;
					}
				}
			}

			// QUANTITY REQUIREMENT (aggregate across all required buy_variants_ids if provided, else fallback to reference product qty)
			if(promoApplicable && promo.buy_quantity){
				var aggregatedQty = 0;
				if(Array.isArray(promo.buy_variants_ids) && promo.buy_variants_ids.length){
					aggregatedQty = cart.items.reduce(function(sum,li){
						return promo.buy_variants_ids.indexOf(parseInt(li.variant_id,10)) !== -1 ? sum + li.quantity : sum;
					}, 0);
				} else {
					aggregatedQty = prdQty; // Single-line fallback
				}
				if(aggregatedQty < parseInt(promo.buy_quantity,10)) promoApplicable = false;
			}

			if(promoApplicable){
				console.info('Promo applicable:', promo.id || (promo.get_variants_ids && promo.get_variants_ids[0]));
				promo.get_variants_ids.forEach(function(variantId){
					var variantIdNum = parseInt(variantId,10);
					if(isNaN(variantIdNum)) return;
					if(idVariantCurrentCartList.indexOf(variantIdNum) !== -1 || _buyXGetYRuntime.pendingPromoVariants.has(variantIdNum)) return;
					itemsToCreate.push({ variantId: variantIdNum, promo: promo, get_quantity: promo.get_quantity || 1 });
					_buyXGetYRuntime.pendingPromoVariants.add(variantIdNum);
				});
			}
		});

		console.info("itemsToCreate", itemsToCreate);

	  	// Items to add to cart
	  	for (var i = 0; i < itemsToCreate.length; i++) {
		
			// Use theme's native cart.addItemById method which properly handles all events and UI updates
			// Create closure to capture current item data
			(function(itemData) {
				var variantId = parseInt(itemData.variantId,10);
				if(isNaN(variantId)) return;
				
				// Wait for theme to be available, then use its cart methods
				function attemptAddItem() {
					if (window.theme && window.theme.cart && window.theme.cart.addItemById) {
						// Use the theme's native addItemById method
						window.theme.cart.addItemById(variantId, itemData.get_quantity).then(function(result) {
							// Create a product object similar to what the theme expects
							var productPass = result.item || {
								variant_id: variantId,
								quantity: itemData.get_quantity
							};
							productPass.manualCheckoutCode = itemData.promo.manualCheckoutCode;
							_buyXGetYRuntime.pendingPromoVariants.delete(variantId);
							
							console.info("BuyXGetY: Successfully added promotional item using theme's cart method", productPass);
							
							// Show promotional item notification
							buyXgetYData.showPromotionalItemNotification(productPass);
							
							if(objRef.success) objRef.success(productPass);
							
							// The theme automatically handles:
							// - Updating window.theme.cartData
							// - Triggering cart:updated events
							// - Refreshing cart UI components
							// - Updating cart counts
							// - All event bindings remain intact
							
						}).catch(function(error) {
							console.warn("BuyXGetY: Error adding promotional item via theme cart", error);
							_buyXGetYRuntime.pendingPromoVariants.delete(variantId);
							if(objRef.error) objRef.error(error);
						});
					} else {
						// Fallback: retry after a short delay if theme.cart isn't ready yet
						console.info("BuyXGetY: Theme cart not ready, retrying in 100ms...");
						setTimeout(attemptAddItem, 100);
					}
				}
				
				attemptAddItem();
			})(itemsToCreate[i]);
	  	}

	},
	addPromoCode: function(discountCode) {
		$.get("/discount/" + discountCode, function( data ) {
			console.info("addPromoCode", data);
		});
	},
	showPromotionalItemNotification: function(productPass) {
		// Create notification HTML following theme's design patterns
		var notificationHTML = 
			'<div class="buyxgety-notification" id="buyxgety-notification">' +
				'<div class="buyxgety-notification__inner">' +
					'<div class="buyxgety-notification__content">' +
						'<div class="buyxgety-notification__icon">' +
							'<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
								'<path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" fill="currentColor"/>' +
							'</svg>' +
						'</div>' +
						'<div class="buyxgety-notification__text">' +
							'<h4 class="buyxgety-notification__title fs-body-bold">Promotional Item Added</h4>' +
							'<p class="buyxgety-notification__message fs-body-75">A free item has been added to your cart.</p>' +
						'</div>' +
					'</div>' +
					'<button class="buyxgety-notification__close" aria-label="Close notification">' +
						'<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
							'<path d="M12 4L4 12M4 4l8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
						'</svg>' +
					'</button>' +
				'</div>' +
			'</div>';

		// Inject CSS if not already present
		if (!document.querySelector('#buyxgety-notification-styles')) {
			var styles = 
				'<style id="buyxgety-notification-styles">' +
					'.buyxgety-notification {' +
						'position: fixed;' +
						'top: 20px;' +
						'right: 20px;' +
						'z-index: 9999;' +
						'max-width: 380px;' +
						'background: var(--color-background-popups-drawers, #fff);' +
						'border: 1px solid var(--color-border-popups-drawers, #e5e5e5);' +
						'border-radius: 8px;' +
						'box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);' +
						'transform: translateX(100%);' +
						'opacity: 0;' +
						'transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);' +
					'}' +
					'.buyxgety-notification.show {' +
						'transform: translateX(0);' +
						'opacity: 1;' +
					'}' +
					'.buyxgety-notification__inner {' +
						'display: flex;' +
						'align-items: flex-start;' +
						'padding: 16px;' +
						'color: var(--color-text-popups-drawers, #000);' +
					'}' +
					'.buyxgety-notification__content {' +
						'display: flex;' +
						'align-items: flex-start;' +
						'flex: 1;' +
					'}' +
					'.buyxgety-notification__icon {' +
						'display: flex;' +
						'align-items: center;' +
						'justify-content: center;' +
						'width: 32px;' +
						'height: 32px;' +
						'background: #22c55e;' +
						'color: white;' +
						'border-radius: 50%;' +
						'margin-right: 12px;' +
						'flex-shrink: 0;' +
					'}' +
					'.buyxgety-notification__text {' +
						'flex: 1;' +
					'}' +
					'.buyxgety-notification__title {' +
						'margin: 0 0 4px 0;' +
						'font-size: var(--font-size-body-base, 14px);' +
						'font-weight: var(--font-body-bold-weight, 600);' +
						'line-height: 1.3;' +
					'}' +
					'.buyxgety-notification__message {' +
						'margin: 0;' +
						'font-size: var(--font-size-body-75, 13px);' +
						'opacity: 0.8;' +
						'line-height: 1.4;' +
					'}' +
					'.buyxgety-notification__close {' +
						'background: none;' +
						'border: none;' +
						'padding: 4px;' +
						'margin-left: 8px;' +
						'cursor: pointer;' +
						'opacity: 0.6;' +
						'border-radius: 4px;' +
						'transition: opacity 0.2s ease;' +
					'}' +
					'.buyxgety-notification__close:hover {' +
						'opacity: 1;' +
						'background: var(--color-text-alpha-05, rgba(0, 0, 0, 0.05));' +
					'}' +
					'@media (max-width: 479px) {' +
						'.buyxgety-notification {' +
							'top: 10px;' +
							'right: 10px;' +
							'left: 10px;' +
							'max-width: none;' +
						'}' +
					'}' +
				'</style>';
			document.head.insertAdjacentHTML('beforeend', styles);
		}

		// Remove any existing notification
		var existingNotification = document.querySelector('#buyxgety-notification');
		if (existingNotification) {
			existingNotification.remove();
		}

		// Add notification to DOM
		document.body.insertAdjacentHTML('beforeend', notificationHTML);
		var notification = document.querySelector('#buyxgety-notification');

		// Show notification with animation
		setTimeout(function() {
			notification.classList.add('show');
		}, 100);

		// Auto-hide after 4 seconds
		var autoHideTimeout = setTimeout(function() {
			buyXgetYData.hidePromotionalItemNotification();
		}, 4000);

		// Add close button functionality
		var closeButton = notification.querySelector('.buyxgety-notification__close');
		closeButton.addEventListener('click', function() {
			clearTimeout(autoHideTimeout);
			buyXgetYData.hidePromotionalItemNotification();
		});
	},
	hidePromotionalItemNotification: function() {
		var notification = document.querySelector('#buyxgety-notification');
		if (notification) {
			notification.classList.remove('show');
			setTimeout(function() {
				if (notification && notification.parentNode) {
					notification.parentNode.removeChild(notification);
				}
			}, 300);
		}
	}
};

// Special loading hausoftools
buyXgetYData.getBuyXGetY();

let limitRety = 1000

// Setup theme internal event listeners for progress updates
function setupThemeEvents() {
	if (window.theme && window.theme.pubsub && window.theme.pubsub.on) {
		// Listen to theme's internal cart events for progress updates
		window.theme.pubsub.on("cart:updated", function(evt) {
			console.log("Theme pubsub: cart:updated event detected");
			if (typeof window.updatePromotionProgress === 'function') {
				const cart = evt && evt.detail ? evt.detail.cart : null;
				scheduleBuyXGetY(cart);
			}
		});
		
		window.theme.pubsub.on(["quantity-update:subtract", "quantity-update:add", "quantity-update:remove"], function(evt) {
			console.log("Theme pubsub: quantity event detected - updating progress");
			if (typeof window.updatePromotionProgress === 'function') {
				const cart = evt && evt.detail ? evt.detail.cart : null;
				scheduleBuyXGetY(cart);
			}
		});
		
		console.log("Setup theme internal event listeners for progress updates via window.theme.pubsub");
	} else {
		// Retry after a delay if theme isn't ready yet
		if(limitRety > 0){
			limitRety -= 1;
			setTimeout(setupThemeEvents, 100);
		}
	}
}

// Setup events after a small delay to ensure theme is loaded
setTimeout(setupThemeEvents, 100);

// Unified promotion check with debounce & cart hash guard
async function _runBuyXGetY(cartRaw){
	try {
		// Always fetch freshest cart to avoid race conditions
		const cart = cartRaw || (window.theme && window.theme.cart ? await window.theme.cart.get() : null);
		if(!cart) return;
		const newHash = _buyXGetYRuntime.hashCart(cart);

		// Helper: determine if any eligible promo gift is missing (so we should still evaluate even if hash unchanged)
		function eligibleGiftMissing(){
			if(!buyXgetYData.buy_x_get_y.length) return false;
			var cartIds = cart.items.map(function(li){ return parseInt(li.variant_id,10); });
			for(var i=0;i<buyXgetYData.buy_x_get_y.length;i++){
				var p = buyXgetYData.buy_x_get_y[i];
				// Basic lightweight eligibility mirror (spend or variant presence)
				var spendOk = true, variantsOk = true, qtyOk = true;
				if(p.buy_value && p.buy_collections && p.buy_collections.length){
					var handles = p.buy_collections.map(function(c){return (c.handle||c.title||'').toLowerCase();});
					var spend = 0;
					cart.items.forEach(function(li){
						var vLower = (li.vendor||'').toLowerCase();
						if(handles.indexOf(vLower)!==-1) spend += (li.price/100)*li.quantity;
					});
					if(spend < parseFloat(p.buy_value)) spendOk = false;
				}
				if(Array.isArray(p.buy_variants_ids) && p.buy_variants_ids.length){
					for(var j=0;j<p.buy_variants_ids.length;j++) if(cartIds.indexOf(parseInt(p.buy_variants_ids[j],10))===-1){ variantsOk=false; break; }
				}
				if(p.buy_quantity){
					var agg = 0;
					if(Array.isArray(p.buy_variants_ids) && p.buy_variants_ids.length){
						cart.items.forEach(function(li){ if(p.buy_variants_ids.indexOf(parseInt(li.variant_id,10))!==-1) agg += li.quantity; });
					} else {
						agg = cart.items.length ? cart.items[cart.items.length-1].quantity : 0;
					}
					if(agg < parseInt(p.buy_quantity,10)) qtyOk = false;
				}
				var applicable = spendOk && variantsOk && qtyOk;
				if(applicable){
					// Check gifts
					if(Array.isArray(p.get_variants_ids)){
						for(var g=0; g<p.get_variants_ids.length; g++){
							var gId = parseInt(p.get_variants_ids[g],10);
							if(cartIds.indexOf(gId)===-1) return true; // missing gift
						}
					}
				}
			}
			return false;
		}

		if(newHash === _buyXGetYRuntime.lastCartHash && !eligibleGiftMissing()){
			_buyXGetYRuntime.log('No cart changes – skipping promo evaluation (no missing gifts)');
			return;
		}

		// Heuristic: last modified item (prefer last) for qty-based promos
		const referenceItem = cart.items && cart.items.length ? cart.items[cart.items.length - 1] : null;
		buyXgetYData.addBuyXGetY(referenceItem, {
			success: function(productPass){ _buyXGetYRuntime.log("Promo added", productPass.variant_id); },
			error: function(err){ console.warn("BuyXGetY: add error", err); }
		}, cart, referenceItem ? referenceItem.quantity : 1);

		// Update last hash AFTER attempting promo additions so second event can still trigger if needed
		_buyXGetYRuntime.lastCartHash = newHash;
	} catch(e){ console.warn("BuyXGetY: _runBuyXGetY error", e); }
}

function scheduleBuyXGetY(cart){
	clearTimeout(_buyXGetYRuntime.debounceTimer);
	_buyXGetYRuntime.debounceTimer = setTimeout(function(){ _runBuyXGetY(cart); }, 80);
}

// Also listen for item-added events for immediate response to new additions
document.addEventListener("cart:item-added", function(evt){
	// Re-evaluate quickly after an item is added
	scheduleBuyXGetY(window.theme && window.theme.cartData ? window.theme.cartData : null);
});